export const TIPOS_OTROS_SERVICIOS = {
  EXTRAMURAL: '1',
  TIQUETERA: '2',
}
